module.exports = __webpack_public_path__ + "img/viewbox.c33a62a4.webp";